// extracted by mini-css-extract-plugin
export default {"card":"InfoCard_card__FxjLE"};